import { create } from "zustand";
import { computeState } from "@/features/betslip/stores/computed";
import {
  initialSelectionsState,
  selectionsSlice,
} from "@/features/betslip/stores/slices/selections";
import {
  initialSessionState,
  sessionSlice,
} from "@/features/betslip/stores/slices/session";
import {
  initialStakesState,
  stakesSlice,
} from "@/features/betslip/stores/slices/stakes";
import {
  initialPromoCashState,
  promoCashSlice,
} from "@/features/betslip/stores/slices/promoCash";
import {
  initialTokensState,
  tokensSlice,
} from "@/features/betslip/stores/slices/tokens";
import {
  initialSubmissionState,
  submissionSlice,
} from "@/features/betslip/stores/slices/submission";
import {
  initialOverlayState,
  overlaySlice,
} from "@/features/betslip/stores/slices/overlay";
import {
  initialUpdatesState,
  updatesSlice,
} from "@/features/betslip/stores/slices/updates";
import {
  initialTabState,
  tabSlice,
} from "@/features/betslip/stores/slices/tab";
import type {
  BetslipActions,
  BetslipState,
  BetslipStore,
  BetslipComputed,
} from "@/features/betslip/stores/types";

export const initialBetslipState: BetslipStore = {
  ...initialSelectionsState,
  ...initialSessionState,
  ...initialStakesState,
  ...initialPromoCashState,
  ...initialTokensState,
  ...initialSubmissionState,
  ...initialOverlayState,
  ...initialUpdatesState,
  ...initialTabState,
};

const useBetslipStore = create<BetslipState>()(
  computeState((set, get, store) => ({
    ...selectionsSlice(set, get, store),
    ...sessionSlice(set, get, store),
    ...stakesSlice(set, get, store),
    ...promoCashSlice(set, get, store),
    ...tokensSlice(set, get, store),
    ...submissionSlice(set, get, store),
    ...overlaySlice(set, get, store),
    ...updatesSlice(set, get, store),
    ...tabSlice(set, get, store),
  })),
);

export { useBetslipStore };
export type { BetslipStore, BetslipActions, BetslipState, BetslipComputed };
